// MP Research Hub — search/filter
document.addEventListener('DOMContentLoaded', function(){
  document.querySelectorAll('.mp-hub').forEach(function(root){
    var input = root.querySelector('.mp-hub__bar .mp-hub__search, .mp-hub__bar input[type="search"]');
    var posts = Array.from(root.querySelectorAll('.mp-grid .mp-post'));
    var empty = root.querySelector('.mp-empty');

    if(!input || posts.length === 0) return;

    function apply(){
      var term = (input.value || '').trim().toLowerCase();
      var shown = 0;
      posts.forEach(function(card){
        var title = card.dataset.title || '';
        var tags = card.dataset.tags || '';
        var hit = !term || title.indexOf(term) > -1 || tags.indexOf(term) > -1;
        card.style.display = hit ? '' : 'none';
        if(hit) shown++;
      });
      if(empty) empty.hidden = shown !== 0;
    }

    input.addEventListener('input', apply);
  });
});
